import type { Patient } from "~/api/patients";

export const getPatientInitials = ({ name, surname }: Patient) =>
  (name.charAt(0) + surname.charAt(0)).toUpperCase();
